__turbopack_context__.v({
  "className": "instrument_serif_5f67038a-module__AI2AfG__className",
});
